import controller from './thing-star.controller';

const template = require('./thing-star.html');

export default {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-star/thing-star.component.js